// extracted by mini-css-extract-plugin
export default {"pathSeparator":"Breadcrumb-pathSeparator__JqN6u"};